<template>
  <component
    :is="isButton ? 'button' : 'a'"
    :v-bind="$attrs"
    :title="label"
    class="
      flex
      items-center
      transition-colors
      duration-100
      bg-transparent
      hover:bg-palette-neutral-20/80
      rounded-full
      hover:text-text
      text-text text-default
      font-normal
      appearance-none
      border-none
      p-2
      gap-2
      group
      justify-around
      text-left
      w-full
    "
    v-on="{ ...$listeners }"
    @click.stop
  >
    <span class="flex-none flex items-center justify-center w-6">
      <slot name="icon">
        <svg
          v-if="icon == 'file'"
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="group-hover:fill-[#4461D7]"
            d="M4 14H12V16H4V14ZM4 10H12V12H4V10ZM10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H9V7H14V18Z"
            fill="#8F9BB3"
          />
        </svg>
        <svg
          v-else-if="icon === 'website'"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="group-hover:fill-[#4461D7]"
            d="M10 0C4.47581 0 0 4.47581 0 10C0 15.5242 4.47581 20 10 20C15.5242 20 20 15.5242 20 10C20 4.47581 15.5242 0 10 0ZM17.2298 6.45161H14.5202C14.25 4.97984 13.8145 3.67742 13.2621 2.63306C14.9919 3.39919 16.3952 4.75806 17.2298 6.45161ZM10 1.93548C10.75 1.93548 11.9597 3.59677 12.5484 6.45161H7.45161C8.04032 3.59677 9.25 1.93548 10 1.93548ZM1.93548 10C1.93548 9.44758 1.99194 8.90726 2.09677 8.3871H5.22984C5.18952 8.91532 5.16129 9.44758 5.16129 10C5.16129 10.5524 5.18952 11.0847 5.22984 11.6129H2.09677C1.99194 11.0927 1.93548 10.5524 1.93548 10ZM2.77016 13.5484H5.47984C5.75 15.0202 6.18548 16.3226 6.7379 17.3669C5.00806 16.6008 3.60484 15.2419 2.77016 13.5484ZM5.47984 6.45161H2.77016C3.60484 4.75806 5.00806 3.39919 6.7379 2.63306C6.18548 3.67742 5.75 4.97984 5.47984 6.45161ZM10 18.0645C9.25 18.0645 8.04032 16.4032 7.45161 13.5484H12.5524C11.9597 16.4032 10.75 18.0645 10 18.0645ZM12.8266 11.6129H7.17339C7.12903 11.0968 7.09677 10.5645 7.09677 10C7.09677 9.43548 7.12903 8.90323 7.17339 8.3871H12.8306C12.875 8.90323 12.9073 9.43548 12.9073 10C12.9073 10.5645 12.871 11.0968 12.8266 11.6129ZM13.2621 17.3669C13.8145 16.3226 14.246 15.0202 14.5202 13.5484H17.2298C16.3952 15.2419 14.9919 16.6008 13.2621 17.3669ZM14.7702 11.6129C14.8105 11.0847 14.8387 10.5524 14.8387 10C14.8387 9.44758 14.8105 8.91532 14.7702 8.3871H17.9032C18.0081 8.90726 18.0645 9.44758 18.0645 10C18.0645 10.5524 18.0081 11.0927 17.9032 11.6129H14.7702Z"
            fill="#8F9BB3"
          />
        </svg>
        <svg
          v-else-if="icon === 'keyboard'"
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="group-hover:fill-[#4461D7]"
            d="M22 0H2C0.895417 0 0 0.895417 0 2V14C0 15.1046 0.895417 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.895417 23.1046 0 22 0ZM22.3333 14C22.3333 14.1838 22.1838 14.3333 22 14.3333H2C1.81621 14.3333 1.66667 14.1838 1.66667 14V2C1.66667 1.81621 1.81621 1.66667 2 1.66667H22C22.1838 1.66667 22.3333 1.81621 22.3333 2V14ZM7.08333 8.58333V7.41667C7.08333 7.14054 6.85946 6.91667 6.58333 6.91667H5.41667C5.14054 6.91667 4.91667 7.14054 4.91667 7.41667V8.58333C4.91667 8.85946 5.14054 9.08333 5.41667 9.08333H6.58333C6.85946 9.08333 7.08333 8.85946 7.08333 8.58333ZM11.0833 8.58333V7.41667C11.0833 7.14054 10.8595 6.91667 10.5833 6.91667H9.41667C9.14054 6.91667 8.91667 7.14054 8.91667 7.41667V8.58333C8.91667 8.85946 9.14054 9.08333 9.41667 9.08333H10.5833C10.8595 9.08333 11.0833 8.85946 11.0833 8.58333ZM15.0833 8.58333V7.41667C15.0833 7.14054 14.8595 6.91667 14.5833 6.91667H13.4167C13.1405 6.91667 12.9167 7.14054 12.9167 7.41667V8.58333C12.9167 8.85946 13.1405 9.08333 13.4167 9.08333H14.5833C14.8595 9.08333 15.0833 8.85946 15.0833 8.58333ZM19.0833 8.58333V7.41667C19.0833 7.14054 18.8595 6.91667 18.5833 6.91667H17.4167C17.1405 6.91667 16.9167 7.14054 16.9167 7.41667V8.58333C16.9167 8.85946 17.1405 9.08333 17.4167 9.08333H18.5833C18.8595 9.08333 19.0833 8.85946 19.0833 8.58333ZM5.08333 12V10.8333C5.08333 10.5572 4.85946 10.3333 4.58333 10.3333H3.41667C3.14054 10.3333 2.91667 10.5572 2.91667 10.8333V12C2.91667 12.2761 3.14054 12.5 3.41667 12.5H4.58333C4.85946 12.5 5.08333 12.2761 5.08333 12ZM21.0833 12V10.8333C21.0833 10.5572 20.8595 10.3333 20.5833 10.3333H19.4167C19.1405 10.3333 18.9167 10.5572 18.9167 10.8333V12C18.9167 12.2761 19.1405 12.5 19.4167 12.5H20.5833C20.8595 12.5 21.0833 12.2761 21.0833 12ZM5.08333 5.16667V4C5.08333 3.72388 4.85946 3.5 4.58333 3.5H3.41667C3.14054 3.5 2.91667 3.72388 2.91667 4V5.16667C2.91667 5.44279 3.14054 5.66667 3.41667 5.66667H4.58333C4.85946 5.66667 5.08333 5.44279 5.08333 5.16667ZM9.08333 5.16667V4C9.08333 3.72388 8.85946 3.5 8.58333 3.5H7.41667C7.14054 3.5 6.91667 3.72388 6.91667 4V5.16667C6.91667 5.44279 7.14054 5.66667 7.41667 5.66667H8.58333C8.85946 5.66667 9.08333 5.44279 9.08333 5.16667ZM13.0833 5.16667V4C13.0833 3.72388 12.8595 3.5 12.5833 3.5H11.4167C11.1405 3.5 10.9167 3.72388 10.9167 4V5.16667C10.9167 5.44279 11.1405 5.66667 11.4167 5.66667H12.5833C12.8595 5.66667 13.0833 5.44279 13.0833 5.16667ZM17.0833 5.16667V4C17.0833 3.72388 16.8595 3.5 16.5833 3.5H15.4167C15.1405 3.5 14.9167 3.72388 14.9167 4V5.16667C14.9167 5.44279 15.1405 5.66667 15.4167 5.66667H16.5833C16.8595 5.66667 17.0833 5.44279 17.0833 5.16667ZM21.0833 5.16667V4C21.0833 3.72388 20.8595 3.5 20.5833 3.5H19.4167C19.1405 3.5 18.9167 3.72388 18.9167 4V5.16667C18.9167 5.44279 19.1405 5.66667 19.4167 5.66667H20.5833C20.8595 5.66667 21.0833 5.44279 21.0833 5.16667ZM17 11.75V11.0833C17 10.8072 16.7761 10.5833 16.5 10.5833H7.5C7.22388 10.5833 7 10.8072 7 11.0833V11.75C7 12.0261 7.22388 12.25 7.5 12.25H16.5C16.7761 12.25 17 12.0261 17 11.75Z"
            fill="#8F9BB3"
          />
        </svg>
        <svg
          v-else-if="icon === 'apps'"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="group-hover:fill-[#4461D7]"
            d="M18.9725 1.028C17.2038 -0.739814 13.7258 -0.157239 10 2.23556C6.27421 -0.1559 2.79707 -0.737135 1.02747 1.028C-0.739444 2.79358 -0.157763 6.26849 2.23726 9.9925C-0.157317 13.7161 -0.738998 17.191 1.02747 18.957C3.7524 21.6797 9.19065 18.2709 10 17.7517C10.812 18.2731 16.2458 21.6784 18.9725 18.957C20.7394 17.1914 20.1578 13.7165 17.7627 9.9925C20.1573 6.26849 20.739 2.79358 18.9725 1.028ZM17.4556 2.54314C18.2038 3.29044 17.9279 5.42922 16.3971 8.09344C14.6101 5.84662 12.9048 4.39755 11.8986 3.59936C13.7785 2.52037 16.4623 1.55343 17.4556 2.54314ZM2.5444 2.54314C3.54169 1.54897 6.23492 2.52796 8.10094 3.59891C5.8519 5.38458 4.4006 7.09034 3.60285 8.09344C2.07209 5.42922 1.7962 3.29044 2.5444 2.54314ZM2.5444 17.441C1.7962 16.6937 2.07209 14.5549 3.60285 11.8907C5.41218 14.1661 7.09338 15.5785 8.10362 16.3803C5.43673 17.911 3.29482 18.1874 2.5444 17.441ZM9.99955 15.1196C7.98845 13.6272 6.38492 12.0335 4.86755 9.9925C5.72645 8.83717 7.36436 6.79973 9.99955 4.84308C12.6356 6.80017 14.2771 8.84253 15.1316 9.9925C13.6271 12.017 12.0267 13.6161 9.99955 15.1196ZM17.4556 17.441C16.7043 18.1878 14.5628 17.9115 11.8959 16.3807C12.9062 15.5794 14.5878 14.1656 16.3971 11.8907C17.9279 14.5549 18.2038 16.6941 17.4556 17.441ZM10 8.56307C9.21029 8.56307 8.56968 9.20279 8.56968 9.99205C8.56968 10.7813 9.20984 11.421 10 11.421C10.7902 11.421 11.4303 10.7813 11.4303 9.99205C11.4303 9.20279 10.7897 8.56307 10 8.56307Z"
            fill="#8F9BB3"
          />
        </svg>
        <svg
          v-else
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="group-hover:fill-[#4461D7]"
            d="M18.125 3H10.625L8.49102 0.866016C8.25664 0.631641 7.93867 0.5 7.60703 0.5H1.875C0.839453 0.5 0 1.33945 0 2.375V13.625C0 14.6605 0.839453 15.5 1.875 15.5H18.125C19.1605 15.5 20 14.6605 20 13.625V4.875C20 3.83945 19.1605 3 18.125 3ZM18.125 13.625H1.875V2.375H7.34844L9.48242 4.50898C9.7168 4.74336 10.0348 4.875 10.3664 4.875H18.125V13.625Z"
            fill="#8F9BB3"
          />
        </svg>
      </slot>
    </span>
    <span class="flex-auto">
      <span class="block w-full truncate">
        {{ label }}
      </span>
    </span>
    <span
      class="
        flex
        items-center
        w-6
        shrink-0
        opacity-0
        group-hover:opacity-100
        group-focus:opacity-100
        focus-within:opacity-100
      "
    >
      <slot name="icon-hover">
        <svg
          v-if="isButton"
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z"
            fill="#646D7D"
          />
        </svg>
        <svg
          v-else
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 0V2H11.59L0 13.59L1.41 15L13 3.41V10H15V0H5Z"
            fill="#646D7D"
          />
        </svg>
      </slot>
    </span>
  </component>
</template>

<script>
export default {
  name: 'HelpCenterGettingStartedMenuItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    isButton: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: 'file',
    },
  },
};
</script>
